import logo from '../images/logo.png'

const Logo = () => {
    return (
        <img src={logo} alt="radom exercise" width="140" height="55" className="d-inline-block align-text-top"/>
    );
}

export default Logo
